<template>
  <AppButton
    icon
    :aria-label="isDark ? 'Switch to light theme' : 'Switch to dark theme'"
    @click="toggleColorMode"
  >
    <!-- Two elements, not one with a dynamic name: UIcon keeps the first icon's
         artwork when only the name changes. -->
    <UIcon v-if="isDark" name="i-heroicons-sun" class="h-5 w-5" />
    <UIcon v-else name="i-heroicons-moon" class="h-5 w-5" />
  </AppButton>
</template>

<script setup lang="ts">
// One theme mechanism: Nuxt UI's colour mode (see colorMode in nuxt.config.ts).
const colorMode = useColorMode()
const isDark = computed(() => colorMode.value === 'dark')

function toggleColorMode() {
  colorMode.preference = isDark.value ? 'light' : 'dark'
}
</script>
